import { usePromisedRequest as promiseRequest } from "../Common/request";
import { resolveWithBody } from "./Utils/utils";
import { User } from "../Common/types";

export type ComplexUser = User & {
    totalCompetitors: number;
};

export default {
    getComplexUser(eventId: number, userId: number): Promise<ComplexUser> {
        return promiseRequest<ComplexUser>({
            url: `/api/admin/events/${eventId}/complex-users/${userId}`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
};
